import { Box, HStack } from '@chakra-ui/react'

interface Props {
  visible: boolean
}

export default function ColorLegend({ visible }: Props) {
  if (!visible) return null

  return (
    <HStack spacing={2} align='center' ml={2} flexWrap='wrap'>
      <Box
        px={3}
        py={1}
        bg='green.500'
        color='white'
        borderRadius='md'
        fontSize='sm'
        fontWeight='semibold'
      >
        Month completed
      </Box>
      <Box
        px={3}
        py={1}
        bg='orange.400'
        color='white'
        borderRadius='md'
        fontSize='sm'
        fontWeight='semibold'
      >
        Month Started
      </Box>
      <Box
        px={3}
        py={1}
        bg='red.500'
        color='white'
        borderRadius='md'
        fontSize='sm'
        fontWeight='semibold'
      >
        Never completed
      </Box>
    </HStack>
  )
}
